import React from 'react';
import { MapInteractiveZone, SpotShape } from '../../../../types';
import { useMapCanvas } from '../../contexts/MapCanvasContext';
import {
  DEFAULT_NODE_CIRCLE_RADIUS,
  DEFAULT_NODE_CIRCLE_STROKE_WIDTH,
  DEFAULT_NODE_RECT_COLOR
} from '../../defines';
import { SpotLayout } from '../../types';
import { CircleProfilePhotoSVG } from './CircleProfilePhotoSVG';
import { getInteractiveZoneStyles } from './helpers';

export interface InteractiveZoneSVGProps {
  shape: SpotShape;
  layout: SpotLayout;
  interactiveZone?: MapInteractiveZone;
  selectIndex?: number;
  isActive?: boolean;
}

export const InteractiveZoneSVG: React.FC<InteractiveZoneSVGProps> = ({
  shape,
  layout,
  interactiveZone,
  selectIndex,
  isActive
}) => {
  const { isPrivacyMode, authenticatedUser, hoveringNode } = useMapCanvas();
  const assignedUser = interactiveZone?.assignedUser || null;
  const actualSchedule = interactiveZone?.actualSchedule || null;

  const circleStyle = getInteractiveZoneStyles({
    isSelected: interactiveZone?.isSelected || false,
    isLastAccessed: interactiveZone?.isLastUsed || false,
    disabled: interactiveZone?.disabled || false,
    notAssignedResource: interactiveZone?.notAssigned || false,
    notAssignedUser: !assignedUser,
    requiresApproval: interactiveZone?.requiresApproval || false,
    hasSchedules: interactiveZone?.hasSchedules || false,
    showCircleProfilePhoto: interactiveZone?.showCircleProfilePhoto || false,
    hasCheckedIn: interactiveZone?.actualSchedule?.has_checked_in || false
  });

  const circleStrokeWidth =
    shape.circleProps?.strokeWidth || DEFAULT_NODE_CIRCLE_STROKE_WIDTH;
  const circleRadius = shape.circleProps?.radius || DEFAULT_NODE_CIRCLE_RADIUS;

  const circleColor =
    selectIndex !== undefined
      ? '#2563eb'
      : hoveringNode?.id === shape.id
        ? '#828383'
        : circleStyle.fill;

  return (
    <g opacity={circleStyle.fillOpacity} id={shape.resource_id}>
      <circle
        id={`shape-${shape.id}-circle`}
        cx={layout.circle.x}
        cy={layout.circle.y}
        r={circleRadius}
        fill={
          isActive
            ? circleColor
            : shape.isInactive
              ? shape.rectProps?.color || DEFAULT_NODE_RECT_COLOR
              : 'grey'
        }
        stroke={circleStyle.stroke}
        strokeWidth={circleStrokeWidth}
      />
      {assignedUser ? (
        <CircleProfilePhotoSVG
          privacy={
            isPrivacyMode && assignedUser.id !== authenticatedUser?.user?.id
          }
          profilePhoto={interactiveZone?.assignedUser?.profile_photo_url || ''}
          radius={circleRadius - circleStrokeWidth / 2}
          layout={layout}
          name={assignedUser.name || ''}
          restricted={true}
        />
      ) : null}
      {interactiveZone?.showCircleProfilePhoto ? (
        <CircleProfilePhotoSVG
          privacy={
            isPrivacyMode &&
            actualSchedule?.user.id !== authenticatedUser?.user?.id
          }
          profilePhoto={actualSchedule?.user.profile_photo_url ?? ''}
          radius={circleRadius - circleStrokeWidth / 2}
          layout={layout}
          name={actualSchedule?.user.name || ''}
        />
      ) : null}
    </g>
  );
};
